// extracted by mini-css-extract-plugin
export var badge = "_hg-2";
export var detailsPanel = "_hg-0";
export var resultRow = "_hg-1";